import { React, useState } from 'react';
import { isNullOrUndefined } from 'utils/validationUtil';
import { updatePasswordToBackend } from 'app/services/user.service';
import { handleAxiosError } from "app/services/app.error.handler";
import { parseApiError } from "app/services/api.error.parser";
import {
    Card,
    Button,
    TextField,
    Alert, IconButton, Collapse
} from "@mui/material";
import { Close as CloseIcon } from "components/icons";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { ConfirmDialog } from "app/components/ConfirmDialog";

export const ChangePasswordView = () => {
    const [currentPassword, setCurrentPassword] = useState(''); // username is email in our application
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("info"); // "error" or "warning" or "info" or "success"
    const [confirmOpen, setConfirmOpen] = useState(false);
/**
 * token and isLogin are session state variables
 * @param {*} props 
 */

const changePasswordActivityHandler = async () => {
    
    const passwordObject = {
        currentPassword,
        newPassword,
        confirmNewPassword
    };

    await updatePasswordToBackend(passwordObject)
    .then((response) => {
        if(response.data.success === true) {
            setSuccessAction(response.data.message);
            clearAction();
            clearChangePasswordForm();
        }
    })
    .catch(error=>{
        const parsed = parseApiError(error);
        setMessage(<p>{parsed.message}</p>);
        setOpen(true);
        setSeverity("error");
        clearAction();
        handleAxiosError(error);
    });
};

const setSuccessAction = (message) => {
    setMessage(message);
    setOpen(true);
    setSeverity("success")
}

const clearAction = () => {
    setTimeout(()=>{
        setMessage('');
        setOpen(false);
    }, 5000);
}

const clearChangePasswordForm = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmNewPassword("");
    document.getElementById("password").value = "";
    document.getElementById("new-password").value = "";
    document.getElementById("confirm-password").value = "";
}

const confirmNewPasswordActivity = (e) => {
    e.preventDefault();

    if((isNullOrUndefined(currentPassword) || currentPassword?.trim() === "") || (isNullOrUndefined(newPassword) || newPassword?.trim() === "") || (isNullOrUndefined(confirmNewPassword) || confirmNewPassword?.trim() === "")) {
        window.alert("All Fields are mandatory");
        return;
    }
    
    const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])(?=\S+$).{8,}$/;
    if(!regex.test(newPassword))
    {
        setMessage(<><p><strong>User password</strong></p> <ul><li> - must have at least a lower case character</li><li> - at least an upper case character</li><li> - at least a digit</li><li> - at least a special character</li><li> - should not have any whitespaces</li><li> - and minimum length should be 8 characters</li></ul></>);
        setOpen(true);
        setSeverity("warning");
        clearAction();
        return;
    }

    if(newPassword !== confirmNewPassword) {
        setMessage(<p>New password & Confirm password doesn't match</p>);
        setOpen(true);
        setSeverity("warning");
        clearAction();
        return;
    }

    setConfirmOpen(true);
    
};



return (
        // Laid out like Reset User Password: a centred card of the same width, header and spacing.
        <MDBox sx={{ display: "flex", justifyContent: "center", mt: 5, px: 2 }}>
            <Card sx={{ width: "100%", maxWidth: 520 }}>
                <MDBox
                    mx={2}
                    mt={-3}
                    py={2}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                >
                    <MDTypography variant="h6" color="white">
                        Change Password
                    </MDTypography>
                </MDBox>

                <MDBox px={3} pt={2}>
                    <MDTypography variant="body2" color="text">
                        Enter your current password, then choose a new one and type it again to confirm.
                    </MDTypography>
                </MDBox>

                <form noValidate>
                    <MDBox px={3} pt={2}>
                        <MDBox mb={2}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="password"
                                label="Password"
                                type="password"
                                name="password"
                                autoComplete="Enter Password"
                                onChange={e => setCurrentPassword(e.target.value)}
                            />
                        </MDBox>
                        <MDBox mb={2}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="new-password"
                                label="New Password"
                                type="password"
                                id="new-password"
                                autoComplete="Enter New Password"
                                onChange={e => setNewPassword(e.target.value)}
                            />
                        </MDBox>
                        <MDBox mb={2}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="confirm-password"
                                label="Confirm Password"
                                type="password"
                                id="confirm-password"
                                autoComplete="Enter Confirm password"
                                onChange={e => setConfirmNewPassword(e.target.value)}
                            />
                        </MDBox>

                        <MDBox mb={1}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                onClick={confirmNewPasswordActivity}
                            >
                                Update Password
                            </Button>
                        </MDBox>
                    </MDBox>
                </form>

                <MDBox px={3} pb={3}>
                    <Collapse in={open}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            severity={severity}
                            sx={{ mb: 1 }}
                        >
                            {message}
                        </Alert>
                    </Collapse>
                </MDBox>
            </Card>

            <ConfirmDialog
                title="Confirmation Required!"
                open={confirmOpen}
                setOpen={setConfirmOpen}
                onConfirm={changePasswordActivityHandler}
                yesButtonLabel='Update'
                noButtonLabel='Cancel'
            >
                Are you sure you want to update the password?
            </ConfirmDialog>
        </MDBox>
    );
}
